import { useQuery } from 'react-query';
import { findHotelConfig } from './api.config';

export const useAppConfigQuery = () => {
  return useQuery('hotels/config', findHotelConfig);
};
